module.exports = __webpack_public_path__ + "static/key-basement-a28ac50ee376c20a6d1d854ef3d9df6d.webp";